import GetAllNotificacionesUseCase from '@/modules/notificaciones/application/usecases/GetAllNotificaciones.usecase'
import NotificacionesApiRepository from '@/modules/notificaciones/infrastructure/NotificationesApi.repository'
import CreateNotificacionUsecase from '@/modules/notificaciones/application/usecases/CreateNotificacion.usecase'
import UpdateNotificationUsecase from '@/modules/notificaciones/application/usecases/UpdateNotification.usecase'
import Vue from 'vue'
import { PERFILES } from '@src/perfiles'

export default {
  namespaced: true,

  state: {
    notificaciones: [],
    loading: false,
  },

  getters: {
    all: (state) => state.notificaciones,
    loading: (state) => state.loading,
  },

  mutations: {
    SET_NOTIFICACIONES: (state, payload) => Vue.set(state, 'notificaciones', payload),
    SET_LOADING: (state, payload) => Vue.set(state, 'loading', payload),
    UPDATE_NOTIFICACION: (state, updatedNotificacion) => {
      const index = state.notificaciones.findIndex((n) => n.id === updatedNotificacion.id)
      if (index !== -1) {
        Vue.set(state.notificaciones, index, updatedNotificacion)
      }
    },
  },

  actions: {
    fetchAll: async ({ commit }) => {
      commit('SET_LOADING', true)
      try {
        const notificaciones = await new GetAllNotificacionesUseCase(NotificacionesApiRepository).execute()
        commit('SET_NOTIFICACIONES', notificaciones)
      } catch {
        const errorMessage = 'No fue posible obtener las notificaciones.'
        commit('SET_SNACKBAR_MESSAGE', errorMessage, { root: true })
      } finally {
        commit('SET_LOADING', false)
      }
    },

    createNotification: async ({ commit }, notificacion) => {
      try {
        await new CreateNotificacionUsecase(NotificacionesApiRepository).execute(notificacion)
      } catch {
        const errorMessage = 'No fue posible enviar la notificación.'
        commit('SET_SNACKBAR_MESSAGE', errorMessage, { root: true })
        throw new Error(errorMessage)
      }
    },

    updateNotification: async ({ commit }, { idNotificacion, notificacion }) => {
      try {
        const updatedNotificacion = await new UpdateNotificationUsecase(NotificacionesApiRepository).execute(
          idNotificacion,
          notificacion,
          localStorage.getItem('perfil')
        )
        commit('UPDATE_NOTIFICACION', updatedNotificacion)
      } catch {
        const errorMessage = 'No fue posible actualizar la notificación.'
        commit('SET_SNACKBAR_MESSAGE', errorMessage, { root: true })
        throw new Error(errorMessage)
      }
    },
  },
}
